var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterPolo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 88.7,
    cy: 58.9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,44.5c2.6,0,5.3-1,7.3-3c4-4,4-10.5,0-14.5c-2-2-4.6-3-7.3-3s-5.3,1-7.3,3c-4,4-4,10.5,0,14.5 C71.9,43.5,74.5,44.5,77.1,44.5z M71.8,28.9c1.4-1.4,3.3-2.2,5.3-2.2s3.9,0.8,5.3,2.2c3,3,3,7.7,0,10.7c-1.4,1.4-3.3,2.2-5.3,2.2 s-3.9-0.8-5.3-2.2c-1.4-1.4-2.2-3.3-2.2-5.3C69.6,32.2,70.4,30.3,71.8,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,95.2c-1.9-1.3-4-2.8-8-2.8c-4,0-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3s-4.7-1.1-6.4-2.3c-1.3-0.9-2.7-1.9-4.7-2.4 L62.9,51.6V33.2c0-2.8-2.3-5.1-5.1-5.1c-2.8,0-5.1,2.3-5.1,5.1v20.6c0,1.4,0.6,2.7,1.5,3.6L68.7,72L47.5,93.1 c-1.2-0.4-2.5-0.7-4.3-0.7c-4,0-6.1,1.5-8,2.8c-1.7,1.2-3.2,2.3-6.4,2.3s-4.7-1.1-6.4-2.3c-1.9-1.3-4-2.8-8-2.8s-6.1,1.5-8,2.8 c-1.7,1.3-3.2,2.3-6.4,2.3v2.7c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8 c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8s6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3 c1.9,1.3,4,2.8,8,2.8c4,0,6.1-1.5,8-2.8c1.7-1.2,3.2-2.3,6.4-2.3s4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8c4,0,6.1-1.5,8-2.8 c1.7-1.2,3.2-2.3,6.4-2.3c3.2,0,4.7,1.1,6.4,2.3c1.9,1.3,4,2.8,8,2.8v-2.7C140.8,97.6,139.3,96.5,137.6,95.2z M86.4,97.6 c-3.2,0-4.7-1.1-6.4-2.3c-0.4-0.3-0.7-0.5-1.1-0.8l0,0l6.2-6.2l7.3,7.3l0,0C90.8,96.7,89.3,97.6,86.4,97.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterPolo);
export default __webpack_public_path__ + "static/media/waterPolo.91b3b546d89509fb1a0c28bc24942811.svg";
export { ForwardRef as ReactComponent };